<template>
  <v-card class="mt-5" height='100%'>
      <v-container fluid class="pa-5">
        <v-row>
          <v-col cols="12">
            <span class="pt-5" id="highestPressure">Your Stocks with Highest Pressure</span>
          </v-col>
          <v-col class="mt-5" cols="12">
            <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
            <v-data-table
              :disable-sort="true"
              :disable-pagination="true"
              hide-default-footer
              v-show="!listLoad"
              :headers="headers"
              :items="items"
              :mobile-breakpoint="0"
            >
              <template v-slot:[`header.pressure`]>
                Pressure <br> <span class="text-no-wrap"> ($ in millions) </span>
              </template>
              <template v-slot:[`header.days_to_trade`]>
                 Days <br> <span class="text-no-wrap"> to Trade </span>
              </template>

              <template v-slot:item="row">
                <tr >
                  <td>
                    <v-btn
                      class="px-2 mr-2"
                      color="primary"
                      min-width="0"
                      icon
                      small
                      :to="'/stocks/analyze/' + row.item.ric"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            mdi-magnify-plus-outline
                          </v-icon>                        
                        </template>
                        <span>Analyze</span>
                      </v-tooltip> 
                    </v-btn>
                  </td>                  
                  <td>{{ row.item.name }}</td>
                  <td>{{ row.item.ric }}</td>
                  <td>{{ row.item.ticker }}</td>
                  <td class="text-right">{{ (row.item.pressure/1000000) | numeral('0,0') }}</td>
                  <td class="text-right">{{ row.item.days_to_trade }}</td>
                  <td class="text-center">
                    <star-rating :rounded-corners="false" :padding="0" :border-width="3" inactive-color="#13305C"  border-color="#233767" active-color="#cc1166" :increment="0.01" :star-size="20"  :inline="true" :rating="row.item.decile" :show-rating="false" :read-only="true" ></star-rating>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
</template>

<script>
  export default {
    name: 'PortfolioAnalyzeComponentHighestPressure',
    props: ['ptf'],    
    data() {
      return {
        headers: [
          {
            sortable: false,
            text: '',
            align: 'left',
          },          
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          { text: 'RIC', value: 'ric' },          
          { text: 'Ticker', value: 'ticker' },
          { text: 'Pressure ($ in millions)', value: 'pressure', align: 'right' },
          { text: 'Days to Trade', value: 'days_to_trade', align: 'right' },
          {
            sortable: false,
            text: 'Market Rating',
            value: 'decile',
            align: 'center'
          },
        ],
        items: [
        ],
        listLoad: true,
        errorbar: false,        
      }
    },
    mounted () {
      this.getListFromApi()
    },    
    methods: { 
      goToStock(id) {
        this.$router.push({ name: 'StocksAnalyze', params: { stock: id } });
      },           
      async getListFromApi() {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + '/get-user-ptf-potential-buys/' + self.ptf,{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.items = response.data 
          self.listLoad = false
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          //self.errorbar = true
        })
      }
    },
  }
</script>


